$(function(){
	// Disable lastpass on checkout inputs
	$('.checkout-wrapper').find('input').attr('data-lpignore', true);
});